var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  Deferred: () => Deferred
});
function Deferred() {
  let resolve;
  let reject;
  let isPending = true;
  let isResolved = false;
  let isRejected = false;
  const promise = new Promise((innerResolve, innerReject) => {
    resolve = (value) => {
      isPending = false;
      isResolved = true;
      innerResolve(value);
    };
    reject = (reason) => {
      isPending = false;
      isRejected = true;
      innerReject(reason);
    };
  });
  return {
    promise,
    resolve,
    reject,
    isPending: () => isPending,
    isResolved: () => isResolved,
    isRejected: () => isRejected
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Deferred
});
